module.exports = __webpack_public_path__ + "img/pd-img15.a8d4dcd0.png";